<script>
import baseMixin from '@/mixins/baseMixin'
import { TimesheetOperationTypeInts } from '@/constants/disputes/TimesheetOperationType'

/**
 * Returns this value if client or candidate stated did not happen
 */
const DID_NOT_SUBMIT_DELTA_CODE = 9999

export default {
  name: 'DisputesTableSimpleDelta',
  mixins: [baseMixin],
  props: {
    dispute: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasCandidateModifiedTimesheet() {
      if (!this.dispute.candidateHasSubmitted) return false
      return (
        this.dispute.candidateTimesheet.details.operationType ===
        TimesheetOperationTypeInts.MODIFY
      )
    },
    hasClientModifiedTimesheet() {
      if (!this.dispute.clientHasSubmitted) return false
      return (
        this.dispute.clientTimesheet.details.operationType ===
        TimesheetOperationTypeInts.MODIFY
      )
    },
    candidateSubmittedDidNotHappen() {
      if (!this.dispute.candidateHasSubmitted) return false
      return (
        this.dispute.candidateTimesheet.details.operationType ===
        TimesheetOperationTypeInts.CANCEL
      )
    },
    clientSubmittedDidNotHappen() {
      if (!this.dispute.clientHasSubmitted) return false
      return (
        this.dispute.clientTimesheet.details.operationType ===
        TimesheetOperationTypeInts.CANCEL
      )
    },
    showDelta() {
      return (
        this.hasCandidateModifiedTimesheet ||
        this.hasClientModifiedTimesheet ||
        this.candidateSubmittedDidNotHappen ||
        this.clientSubmittedDidNotHappen
      )
    },
    isDidNotHappen() {
      return this.dispute.deltaMinutes === DID_NOT_SUBMIT_DELTA_CODE
    },
    compDidNotHappenTooltipText() {
      return `${
        this.candidateSubmittedDidNotHappen
          ? this.dispute.candidateName
          : this.dispute.clientName
      } stated this booking did not happen`
    },
    isPositiveDelta() {
      return this.dispute.deltaMinutes >= 0
    },
    compDeltaMins() {
      return `${Math.abs(this.dispute.deltaMinutes)} mins`
    },
  },
}
</script>

<template>
  <div v-if="showDelta">
    <div v-if="isDidNotHappen">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" class="cursor-help" v-on="on">
            <v-icon size="14">mdi-alert-circle-outline</v-icon>
            <span class="text-caption ml-1">Didn't happen</span>
          </div>
        </template>
        <span class="ws-pre-wrap">{{ compDidNotHappenTooltipText }}</span>
      </v-tooltip>
    </div>
    <div v-else class="text-caption">
      <v-icon size="14">{{
        isPositiveDelta ? 'mdi-plus' : 'mdi-minus'
      }}</v-icon>
      <span class="text-caption ml-1">{{ compDeltaMins }}</span>
    </div>
  </div>
</template>
